import { WifiOff } from 'lucide-react'
import { Card } from '@/components/ui'

const OfflineSyncPage = () => (
  <div className="p-4">
    <h1 className="text-xl font-bold mb-4">Offline Sync</h1>
    <Card>
      <div className="flex items-center gap-3">
        <WifiOff size={24} className="text-red-500" />
        <p>Sync queue and offline data will appear here</p>
      </div>
    </Card>
  </div>
)

export default OfflineSyncPage
